import { TRANSITION_STATE, TRANSITION_ORIGIN, TRANSITION_TARGET } from '../actions/transition';

export const initialAppState = {
  transitionState: 'exited',
  origin: null,
  target: null
};

const getState = function(state = initialAppState, action) {
  switch (action.type) {
    case TRANSITION_STATE:
      return {
        ...state,
        transitionState: action.transitionState
      };
    case TRANSITION_TARGET:
      return {
        ...state,
        target: action.target
      };
    case TRANSITION_ORIGIN:
      return {
        ...state,
        origin: action.origin
      };

    default:
      return state;
  }
};
export default getState;
